import { createAction } from '@reduxjs/toolkit'

import { ECurrency } from 'types/Enums'

// initializeCurrencyConverter
export const setCurrency = createAction<ECurrency | null>('set_currency')
